<script>
import MenuGridItem from "@components/menu-grid/menu-grid-item.vue";

export default {
  name: "index",
  components: {MenuGridItem}
}
</script>

<template>
  <div class="container mt-10">
    <div class="grid grid-cols-4 gap-4">
      <menu-grid-item
          :route="`/support-areas/internal-control/condusef/reune/general-requests`"
          title="Consultas Generales"></menu-grid-item>

      <menu-grid-item
          :route="`/support-areas/internal-control/condusef/reune/general-claims`"
          title="Reclamaciones Generales"></menu-grid-item>

      <menu-grid-item
          :route="`/support-areas/internal-control/condusef/reune/general-clarifications`"
          title="Aclaraciones Generales"></menu-grid-item>
    </div>
  </div>
</template>

<style scoped>

</style>